import React, { useEffect, useState } from "react";
import OurVision1Img from "../../../../assets/OurVision1.png";
import OurVision2Img from "../../../../assets/OurVision2.png";
import KeyFeaturesBackground from "../../../../assets/KeyFeatures_BackgroundColor.png";
import GlowButton from "../../GlowButton";

const AboutUsNavContent = () => {
  const [active, setActive] = useState(0);

  const slides = [
    {
      title: (
        <>
          <span className="text-white font-extrabold">our </span>
          <span className="text-[#fcb900] font-extrabold">vision &amp; mission</span>
        </>
      ),
      text: (
        <>
          be
          <span className="inline-block scale-x-[-1]">e</span>
          mz is a dynamic digital marketplace built to simplify everyday living
          by bringing essential services right to your fingertips. from
          food and retail to rides, we connect you instantly with what
          matters most. our platform ensures speed, convenience, and trust — all
          in one seamless experience.
        </>
      ),
      img: OurVision1Img,
    }
    ,
    //     {
    //       title: (
    //         <>
    //           <span className="text-white font-extrabold">our </span>
    //           <span className="text-[#fcb900] font-extrabold">journey</span>
    //         </>
    //       ),
    //       text: `from a small vision to a growing platform, beɘmz continues to empower
    // businesses and customers worldwide — redefining digital marketplaces
    // one connection at a time.`,
    //       img: OurVision2Img,
    //     },
  ];

  useEffect(() => {
    const id = setInterval(() => {
      setActive((p) => (p === slides.length - 1 ? 0 : p + 1));
    }, 500000);
    return () => clearInterval(id);
  }, [slides.length]);

  return (
    <div className="w-full">

      {/* ---------- Section 1 Intro ---------- */}
      <div className="aboutus-intro-wrapper w-full bg-white">
        <section className="w-full flex justify-center">
          <div className="w-full max-w-[400px] md:max-w-[710px] lg-xl:max-w-[900px] xl-2xl:max-w-[1190px] min-h-[290px] px-5 flex items-center pt-8">
            <p className="w-full text-center font-[Lexend] text-[#605959] text-[18px] sm:text-[14px] leading-[1.9] tracking-[0.04em] font-semibold">
              be
              <span className="inline-block scale-x-[-1] tracking-[0px]">
                e
              </span>
              mz is a real-time, restaurant and retail digital market place built to improve customer
              experience and grow your business by bringing essential services right to your fingertips.
              from orders to payments, social media marketing and rides we connect you instantly to who
              matters most - your customer. our platform ensures speed, convenience and trust - all in
              one seamless experience.
            </p>
          </div>
        </section>
      </div>


      {/* ---------- Section 2 Slider ---------- */}
      <div className="aboutus-slider-wrapper w-full flex justify-center">
        <section
          className="
    w-full
    sm:w-[86%]
    md:w-[90%]
    xl-2xl:w-[94%]
    overflow-hidden rounded-[22px]
    mt-6 md:mt-8
    font-[Lexend] text-white

    h-auto
    min-h-fit    /* important: content determines height */
  "
          style={{
            backgroundImage: `url(${KeyFeaturesBackground})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >

          <div className="py-12 sm:py-4 md:py-24 px-3.6 md:px-0">

            {/* Slides Track */}
            <div
              className="flex transition-transform duration-700"
              style={{ transform: `translateX(-${active * 100}%)` }}
            >
              {slides.map((slide, i) => (
                <div
                  key={i}
                  className="min-w-full grid grid-cols-1 md:grid-cols-2 items-center"
                >

                  {/* Left Text */}
                  <div
                    className="
                      max-w-[600px]
                      mx-auto px-[23px] md:ml-10 lg:ml-20 xl:ml-24
                      mt-10 md:mt-14
                      text-center md:text-left
                    "
                  >
                    <h2
                      className="
                        text-[28px] md:text-[40px] lg:text-[44px] xl:text-[50px]
                        leading-tight mb-4
                      "
                    >
                      {slide.title}
                    </h2>

                    <p
                      className="
                        text-[14px] md:text-[18px] lg:text-[20px]
                        leading-[24px] md:leading-[28px] lg:leading-[30px]
                        text-[#E6E2FF]
                        font-normal lowercase mb-6
                      "
                    >
                      {slide.text}
                    </p>

                    {/* <button
                      className="
                        group inline-flex items-center justify-center gap-3
                        min-w-[190px] py-3 rounded-full
                        border border-[#6E3FC6]
                        bg-white text-black
                        text-sm md:text-base font-medium
                        transition-all duration-300
                        hover:bg-[#6E3FC6] hover:text-white
                        mt-4
                      "
                    >
                      free trial

                      <div
                        className="
                          w-6 h-6 rounded-full flex items-center justify-center
                          transition-all duration-300
                          bg-[#6E3FC6] group-hover:bg-white
                        "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="
                            w-3.5 h-3.5 transition-all duration-300
                            stroke-white group-hover:stroke-[#6E3FC6]
                          "
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M7 17L17 7M8 7h9v9" />
                        </svg>
                      </div>
                    </button> */}

                    <span className="mt-10 flex justify-center  ml-0 md:ml-[-5.8rem] md-2xl:ml-[-9rem] lg-xl:ml-[-8rem] xl-2xl:ml-[-22rem]  items-start">
                      <GlowButton btnValue="free trial" btn1="2" onClick={() => window.location.href = "/business/get-started"}></GlowButton>
                    </span>

                  </div>

                  {/* Right Image */}
                  <div
                    className="
                      flex justify-center md:justify-end
                      mt-6 md:mt-0
                    "
                  >
                    <img
                      src={slide.img}
                      alt="slide visual"
                      className="
                        w-[80%] md:w-[310px] lg-xl:w-[440px] xl-2xl:w-[1000px]
                        max-w-[350px] md:max-w-[480px] lg:max-w-[520px] xl:max-w-[569px]
                        rounded-xl shadow-lg object-cover
                        mx-auto md:mr-10
                      "
                    />
                  </div>

                </div>
              ))}
            </div>

            {/* Navigation Dots */}
            {/* <div className="flex justify-center mt-6 md:mt-10">
              <div className="flex items-center gap-2">
                {slides.map((_, i) => {
                  const isActive = active === i;
                  return (
                    <button
                      key={i}
                      onClick={() => setActive(i)}
                      aria-label={`Go to slide ${i + 1}`}
                      aria-current={isActive ? "true" : "false"}
                      className={`
                        rounded-full transition-all duration-300
                        focus:outline-none focus:ring-2 focus:ring-white/70
                        ${isActive ? "w-8 h-1 bg-white/90" : "w-1 h-1 bg-white/60 hover:bg-white/80"}
                      `}
                    />
                  );
                })}
              </div>
            </div> */}

          </div>
        </section>
      </div>

    </div>
  );
};

export default AboutUsNavContent;
